(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["the-perspective"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.custom-newsletter-form');
    forms.forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const email = form.querySelector('[name="contact[email]"]').value;

        try {
          const response = await fetch('https://hook.eu2.make.com/2lkbelahji42ssfsl8qbgyq9v6l0uomj', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
          });

          if (response.ok) {
            form.querySelector('.form-posted-successfully')?.classList.remove('hidden');
            form.reset();
          } else {
            form.querySelector('.form-errors-container')?.classList.remove('hidden');
          }
        } catch (error) {
          console.error('Error: ' + error.message);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
